export default function TopNav() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/70 bg-background-50/80 backdrop-blur-md">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
        {/* 站点标 */}
        <a href="#top" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-24-hours-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-lg font-bold tracking-tight text-foreground-950">
              扒哥黑料
            </span>
            <span className="block text-[10px] tracking-[0.2em] text-foreground-500">
              证据链 · 一锤到底
            </span>
          </span>
        </a>

        {/* 桌面锚点导航 */}
        <nav className="hidden md:flex items-center gap-7">
          {[
            { href: "#hammer", label: "今日在锤" },
            { href: "#archive", label: "合集索引" },
            { href: "#chain", label: "证据链" },
            { href: "#timeline", label: "时间轴" },
            { href: "#heat", label: "热度榜" },
            { href: "#note", label: "编辑声明" },
          ].map((it) => (
            <a
              key={it.href}
              href={it.href}
              className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
            >
              {it.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#archive"
            className="hidden sm:inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-search-line text-sm" aria-hidden="true"></i>
            检索锤文
          </a>
          <a
            href="#chain"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-stack-line text-sm" aria-hidden="true"></i>
            追完整证据链
          </a>
          {/* 移动端菜单按钮 */}
          <button
            type="button"
            aria-label="菜单"
            className="md:hidden flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700"
          >
            <i className="ri-menu-3-line text-lg" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </header>
  );
}